import React from "react";
import {View, Svg, Line, G, Rect, Circle, StyleSheet} from "@react-pdf/renderer";
import MarkDamagesOnTrailerPrintout from "../markDamagesOnTrailerPrintout";
import {SideType} from "../../../../../models/transport";
import {DamageLocation, EquipmentType} from "../../../../../models/tcr";
import {OrderFilesUtils} from "../../../../../../helpers/orderFilesUtils";

const tcrReportStyles = StyleSheet.create(OrderFilesUtils.tcrReportStyles);

export default function Left(): React.ReactElement {
    return (
        <View style={tcrReportStyles.centerPicture}>
            <Svg
                viewBox="0 0 420 213"
                style={tcrReportStyles.pictureSize}
                id="trailer-left"
            >
                <Rect
                    x="-1"
                    y="1"
                    width="418"
                    height="141.415"
                    transform="matrix(-1 0 0 1 418 0)"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                />
                <Rect
                    x="-1"
                    y="1"
                    width="13.3659"
                    height="64.5854"
                    transform="matrix(-1 0 0 1 64.5854 140.854)"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="LEG-1"
                />
                <Line
                    x1="0"
                    y1="-1"
                    x2="40.0037"
                    y2="-1"
                    transform="matrix(-0.768221 0.640184 0.640184 0.768221 97.3171 143.415)"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="LEG-2"
                />
                <Line
                    x1="0"
                    y1="-1"
                    x2="87.0732"
                    y2="-1"
                    transform="matrix(-1 0 0 1 192.073 156.219)"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="BICYCLE_PROTECTION-2"
                />
                <Line
                    x1="0"
                    y1="-1"
                    x2="87.0732"
                    y2="-1"
                    transform="matrix(-1 0 0 1 192.073 176.708)"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="BICYCLE_PROTECTION-1"
                />
                <Circle
                    r="31.0122"
                    transform="matrix(-1 0 0 1 387.988 180.549)"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    cx="0"
                    cy="0"
                    key="WHEEL__REAR-1"
                />
                <Circle
                    r="31.0122"
                    transform="matrix(-1 0 0 1 316.281 180.549)"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    cx="0"
                    cy="0"
                    key="WHEEL__CENTER-1"
                />
                <Circle
                    r="31.0122"
                    transform="matrix(-1 0 0 1 247.134 180.549)"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    cx="0"
                    cy="0"
                    key="WHEEL__FRONT-1"
                />
                <Circle
                    r="7.96342"
                    transform="matrix(-1 0 0 1 387.988 180.549)"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    cx="0"
                    cy="0"
                    key="WHEEL__REAR-2"
                />
                <Circle
                    r="7.96342"
                    transform="matrix(-1 0 0 1 316.28 180.549)"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    cx="0"
                    cy="0"
                    key="WHEEL__CENTER-2"
                />
                <Circle
                    r="7.96342"
                    transform="matrix(-1 0 0 1 247.134 180.549)"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    cx="0"
                    cy="0"
                    key="WHEEL__FRONT-2"
                />
                <Rect
                    opacity={1}
                    fill="#8e8e8e"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="1.47533"
                    width="417.65244"
                    height="16.998671"
                    x="1.1867983"
                    y="123.5017"
                    key="SIDE_BOARD"
                />
                <Rect
                    opacity={1}
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="0.922935"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="209.54654"
                    height="62.077065"
                    x="0.51313812"
                    y="0.5713495"
                    key="TARPAULIN__LEFT_TOP"
                />
                <Rect
                    opacity={1}
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="0.923598"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="209.51569"
                    height="62.163387"
                    x="0.50424224"
                    y="62.599976"
                    key="TARPAULIN__LEFT_BOTTOM"
                />
                <Rect
                    opacity={1}
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="0.922983"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="209.51579"
                    height="62.092644"
                    x="210.05272"
                    y="62.498535"
                    key="TARPAULIN__RIGHT_BOTTOM"
                />
                <Rect
                    opacity={1}
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="0.922966"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="209.51981"
                    height="62.077122"
                    x="210.036"
                    y="0.46243227"
                    key="TARPAULIN__RIGHT_TOP"
                />
                <G
                    transform="translate(-39.741094,-8.9769377)"
                    key="TARPAULIN__LEFT_TOP.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.LEFT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.LEFT_TOP}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(174.72344,-7.2117975)"
                    key="TARPAULIN__RIGHT_TOP.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.LEFT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.RIGHT_TOP}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(-40.182384,55.450681)"
                    key="TARPAULIN__LEFT_BOTTOM.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.LEFT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.LEFT_BOTTOM}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(172.9583,55.450681)"
                    key="TARPAULIN__RIGHT_BOTTOM.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.LEFT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.RIGHT_BOTTOM}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(72.786592,96.931477)"
                    key="SIDE_BOARD.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.LEFT}
                        equipmentType={EquipmentType.SIDE_BOARD}
                        damageLocation={null}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(109.85454,141.50127)"
                    key="WHEEL__FRONT.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.LEFT}
                        equipmentType={EquipmentType.WHEEL}
                        damageLocation={DamageLocation.FRONT}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(178.69501,141.50127)"
                    key="WHEEL__CENTER.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.LEFT}
                        equipmentType={EquipmentType.WHEEL}
                        damageLocation={DamageLocation.CENTER}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(251.06576,141.05998)"
                    key="WHEEL__REAR.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.LEFT}
                        equipmentType={EquipmentType.WHEEL}
                        damageLocation={DamageLocation.REAR}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(9.0635568,132.67556)"
                    key="BICYCLE_PROTECTION.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.LEFT}
                        equipmentType={EquipmentType.BICYCLE_PROTECTION}
                        damageLocation={null}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(-76.367754,137.08841)"
                    key="LEG.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.LEFT}
                        equipmentType={EquipmentType.LEG}
                        damageLocation={null}
                        fontSize={16}
                        textY="46"
                    />
                </G>
            </Svg>
        </View>
    );
}